import PropTypes from 'prop-types';
import React from 'react';
import Carousel from 'nuka-carousel';
import { Image } from 'react-bootstrap';
import './PhotoSwipeThumbnails.scss';

class PhotoSwipeThumbnails extends React.Component {
	/**
	 * method uses the viewport and number of slides to display in order to have the currently viewed image centered
	 * when there are enough images on either side,. or left or right aligned when its' towards the beginning or end of
	 * the images array
	 * @param props {optional} - viewportWidth, items, currentIndex. Uses this.props if not supplied.
	 * @returns index that should be centered in the thumbnail display
	 */
	getCurrentMiddleIndex() {
		const slidesToShow = this.getSlidesToShow();
		const { images, currentIndex } = this.props;

		const halfOfVisibleSlides = Math.round(slidesToShow / 2);

		let slideToBeCentered = currentIndex;
		if (slideToBeCentered < halfOfVisibleSlides) {
			const shouldStartSlidingIndex = halfOfVisibleSlides;
			if (slideToBeCentered < shouldStartSlidingIndex) {
				slideToBeCentered = shouldStartSlidingIndex - 1;
			}
		} else {
			// -1 because we're looking for index, not length
			const shouldStopSlidingIndex = images.length - halfOfVisibleSlides;
			if (slideToBeCentered > shouldStopSlidingIndex) {
				slideToBeCentered = shouldStopSlidingIndex;
			}
		}

		return slideToBeCentered;
	}

	getSlidesToShow = () => {
		const { viewportWidth } = this.props;
		const slidesToShow = viewportWidth / 118;

		return !Number.isNaN(slidesToShow) ? slidesToShow : 0;
	};

	render() {
		const slidesToShow = this.getSlidesToShow();
		const currentMiddleIndex = this.getCurrentMiddleIndex();

		// Disable vertical scrolling when swiping on the carousel on a mobile device.
		// https://github.com/FormidableLabs/nuka-carousel/issues/874.
		// The fix isn't released yet. It should be remove if we upgraded to the fix version
		const carouselStyle = { touchAction: 'pan-y' };

		const {
			currentIndex,
			images,
			isDesktop,
			trackGa,
			goToPhoto,
			updateIsBeingDragged
		} = this.props;

		const sliderProps = {
			swiping: !isDesktop,
			cellSpacing: 4,
			dragging: false,
			cellAlign: 'center',
			wrapAround: false,
			speed: 250,
			slidesToShow,
			slideIndex: currentMiddleIndex,
			withoutControls: true,
			style: carouselStyle
		};

		return (
			<div className="pswp-thumbnails fixed-bottom pt-2 pb-2 bg-black">
				<Carousel {...sliderProps}>
					{images.map((image, index) => {
						return (
							<Image
								alt=""
								key={`pswp-thumb-${image.thumbnail}`}
								className={`pswp-thumbnail ws-vehicle-media-thumbnail ${
									index === this.props.currentIndex
										? 'active'
										: ''
								}`}
								src={image.thumbnail}
								onClick={(e) => {
									goToPhoto(index, e);
									updateIsBeingDragged(false);
									trackGa({
										element: 'Thumbnail Carousel',
										result: 'Photo comes into view',
										widgetState: 'Gallery Modal',
										dataToExcludeFromWidgetUserEvent: {
											currentItem: currentIndex + 1,
											totalItems: images.length
										}
									});
								}}
							/>
						);
					})}
				</Carousel>
			</div>
		);
	}
}

PhotoSwipeThumbnails.defaultProps = {
	updateIsBeingDragged: () => {}
};

PhotoSwipeThumbnails.propTypes = {
	currentIndex: PropTypes.number.isRequired,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string,
			thumbnail: PropTypes.string
		})
	).isRequired,
	trackGa: PropTypes.func.isRequired,
	goToPhoto: PropTypes.func.isRequired,
	viewportWidth: PropTypes.number.isRequired,
	isDesktop: PropTypes.bool.isRequired,
	updateIsBeingDragged: PropTypes.func
};

export default PhotoSwipeThumbnails;
